export default __webpack_public_path__ + "static/1733-aa467f32ca9ddb684c4f4fbf73eb536a.gif";